/**
 * @file
 * Attaches the behaviors for the News component.
 */
 !(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.news = {
    attach(context) {

      // event handler for when a filter is selected/changed/etc.
      const $news = $('select[name="field_article_category_target_id"]', context);
      $news.change(function () {
        setTimeout(function() {
          //hack!!! The ajax throbber has an issue with Better Exposed Filters
          //The throbber stays even when the ajax call completes and the view has
          //already changed. This is a hack to remove the throbber. Remove when we can.
          const $throbber = $('.ajax-progress', context);
          if ($throbber.length) {
            $throbber.remove();
          }
          }, 2000);
      });
    },

  };
})(jQuery, Drupal);
